import React from "react";
import NumberFormat from "react-number-format";
import { RenderNumber } from "Utils/renderField/renderReadField";

export const ReprocesoTable = ({ reprocesoHook }) => {
    const { esModoPacas, origenes, cantidades, CambiarCantidad } =
        reprocesoHook;

    const encabezados = esModoPacas
        ? ["PALLET", "PACAS DISPONIBLES", "PACAS A TOMAR"]
        : ["PRODUCTO", "KG DISPONIBLES", "KG A TOMAR"];

    // del reproceso siempre se toman pacas completas
    const decimales = esModoPacas ? 0 : 3;

    return (
        <div className="new-table-wrapper mt-3">
            <table className="table-striped">
                <thead>
                    <tr>
                        {encabezados.map((encabezado) => (
                            <th key={encabezado}>{encabezado}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {origenes.length === 0 && (
                        <tr>
                            <td colSpan={3} className="text-center">
                                {esModoPacas
                                    ? "Este almacén no tiene pacas disponibles"
                                    : "Este almacén no tiene sobrante disponible"}
                            </td>
                        </tr>
                    )}
                    {origenes.map((origen) => (
                        <tr key={origen.id}>
                            <td className="text-center text-nowrap">
                                {origen.etiqueta}
                                {origen.detalle && (
                                    <small className="d-block text-muted">
                                        {origen.detalle}
                                    </small>
                                )}
                            </td>
                            <td className="text-center text-nowrap">
                                <RenderNumber
                                    value={origen.disponible}
                                    decimalScale={decimales}
                                />
                            </td>
                            <td className="text-center">
                                <div
                                    className="mx-auto"
                                    style={{ maxWidth: "140px" }}
                                >
                                    <NumberFormat
                                        className="form-control"
                                        value={cantidades[origen.id]}
                                        thousandSeparator=","
                                        allowNegative={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;

                                            if (floatValue === undefined) {
                                                return true;
                                            }

                                            return (
                                                floatValue <=
                                                    origen.disponible &&
                                                floatValue >= 0
                                            );
                                        }}
                                        onValueChange={(values) => {
                                            CambiarCantidad(
                                                origen.id,
                                                values.floatValue,
                                            );
                                        }}
                                        placeholder="0"
                                        decimalScale={decimales}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
